<template>
  <BasicLayout :left="left" :middle="middle" :right="right">
    <template v-slot:left_view>
      <OrganizationalTree ref="organizationalTree" :nodeSelectProp='getNode' :neid="neidByQryTree" :treeFresh="treeFresh"></OrganizationalTree>
    </template>
    <template v-slot:right_view>
      <ToolBar
        :addBtn="true"
        :delBtn="true"
        :editBtn="true"
        :refreshBtn="true"
        :searchBtn="true"
        @notice="notice"
        @props="props"
      ></ToolBar>
      <div class="h100vh-140">
      <ejs-grid ref="grid" :dataSource='dataSource' :allowPaging="true" :allowResizing='true' :pageSettings="pageSettings" :actionComplete='actionComplete' height="calc(100% - 0px)">
          <e-columns>
            <e-column type='checkbox'  width='40' textAlign='Center'></e-column>
            <e-column field='staffnum' :headerText="$t('SubscriberIms.staffId')" width='110' textAlign='Center' clipMode='EllipsisWithTooltip'></e-column>
            <e-column field='staffname' :headerText="$t('SubscriberIms.staffName')" width='110' textAlign='Center' clipMode='EllipsisWithTooltip'></e-column>
            <e-column field='platenum' :headerText="$t('SubscriberIms.licenseNum')" width='180' textAlign='Center' clipMode='EllipsisWithTooltip'></e-column>
            <e-column field='udn' :headerText="$t('SubscriberIms.subNum')" width='100' textAlign='Center' clipMode='EllipsisWithTooltip'></e-column>
            <e-column field='post' :headerText="$t('SubscriberIms.profession')" width='100' textAlign='Center' clipMode='EllipsisWithTooltip'></e-column>
            <e-column field='worktype' :headerText="$t('SubscriberIms.post')" width='100' textAlign='Center' clipMode='EllipsisWithTooltip'></e-column>
            <e-column field='unitname' :headerText="$t('SubscriberIms.unitName')" width='100' textAlign='Center' clipMode='EllipsisWithTooltip'></e-column>
            <e-column field='unitcode' :headerText="$t('SubscriberIms.unitCode')" width='100' textAlign='Center' clipMode='EllipsisWithTooltip'></e-column>
            <e-column field='telnum' :headerText="$t('SubscriberIms.mobile')" width='100' textAlign='Center' clipMode='EllipsisWithTooltip'></e-column>
            <e-column field='usetype' :headerText="$t('SubscriberIms.use')" width='100' textAlign='Center' clipMode='EllipsisWithTooltip'></e-column>
            <e-column field='terminaltype' :formatter='rtttypeFormat' :headerText="$t('SubscriberIms.terType')" width='100' textAlign='Center' clipMode='EllipsisWithTooltip'></e-column>
          </e-columns>
        </ejs-grid>
        <ejs-pager
          ref="pager"
          :pageSize='pageSettings.pageSize' :currentPage='pageSettings.pageNo' :totalRecordsCount='pageSettings.totalCount'
          @click="getInfo(organization, false)"
        ></ejs-pager>
      </div>
      <CustomDialog
        ref="addDialog"
        v-bind:element="addDialog.element"
        v-bind:styles="addDialog.styles"
      >
        <template v-slot:dialog-content>
          <ImsInfoDialog ref="infoDialog" v-bind:opCode="opCode" v-bind:msgid="msgid" v-bind:neid="neid"></ImsInfoDialog>
        </template>
      </CustomDialog>
      <CustomDialog
        ref="searchDialog"
        v-bind:element="searchDialog.element"
        v-bind:styles="searchDialog.styles"
      >
        <template v-slot:dialog-content>
          <ImsInfoSearchDialog ref="infoSearchDialog" v-bind:opCode="opCode" v-bind:msgid="msgid" v-bind:neid="neid"></ImsInfoSearchDialog>
        </template>
      </CustomDialog>
      <CustomDialog ref='dialogListPage' :element='eleDialogList' :styles='styles'>
        <template v-slot:dialog-content>
          <DialogList ref='dialogList'></DialogList>
        </template>
      </CustomDialog>
    </template>
  </BasicLayout>
</template>

<script>
import BasicLayout from '../../../../layouts/BasicLayout';
import CustomDialog from '../../../../components/common/CustomDialog';
import OrganizationalTree from '../../../../components/subscriberconfig/util/OrganizationalTree';
import ToolBar from '../../../../components/subscriberconfig/imsSubscriber/ToolBar';
import ImsInfoDialog from '../../../../components/subscriberconfig/imsSubscriber/staff/ImsInfoDialog';
import ImsInfoSearchDialog from '../../../../components/subscriberconfig/imsSubscriber/staff/ImsInfoSearchDialog';
import DialogList from '../../../../components/subscriberconfig/util/tipDialog/DialogList';
import { Resize } from '@syncfusion/ej2-vue-grids';
import { EventBus } from '../../../../plugins/eventBus';

export default {
  name: "ImsInfoManagement",
  provide: {
    grid: [Resize]
  },
  data() {
    return {
      neidByQryTree: null,
      qrySearchParam: null,
      dataSource: [],
      left: {
        show: true,
        name: this.$t('SubscriberIms.organization')
      },
      middle: {
        show: false,
        name: ""
      },
      right: {
        show: true,
        crumb: this.$t('SubscriberIms.infoTitle')
      },
      addDialog: {
        element: {
          target: "#app",
          isClose: true,
          refName: "addInfo",
          buttonGroup: [
            {
              click: this.dialogHide,
              buttonModel: { content: `${this.$t("System.cancel")}` }
            },
            {
              click: this.confirmAdd,
              buttonModel: { content: `${this.$t("System.confirm")}` ,isPrimary: true}
            }
          ],
          title: this.$t('SubscriberIms.add')
        },
        styles: {
          width: "810px",
          height: "auto",
          model: true,
          visible: false
        }
      },
      searchDialog: {
        element: {
          target: "#app",
          isClose: true,
          refName: "searchInfo",
          buttonGroup: [
            {
              click: this.searchDialogHide,
              buttonModel: { content: `${this.$t("System.cancel")}` }
            },
            {
              click: this.searchDialogConfirm,
              buttonModel: { content: `${this.$t("System.confirm")}` ,isPrimary: true}
            }
          ],
          title: this.$t('SubscriberIms.qryAdvance')
        },
        styles: {
          width: '30%',
          height: '60%',
          model: true,
          visible: false
        }
      },
      organization: {},
      pageSettings: {
        pageNo: 1,
        pageSize: 100,
        totalCount: 0,
        pageCount: 0,
      },
      pageCount: 4,
      opCode:'',
      msgid: 0,
      neid: 0,
      addMsgid: 27838,
      modMsgid: 27839,
      delMsgid: 27840,
      shwMsgid: 27841,
      vpnid: 0,
      eleDialogList: {
        target: '#app',
        refName: 'dialogList',
        buttonGroup: [
          {
            click: this.closeDialogListTipPage,
            buttonModel: { content: this.$t('SubscriberIms.confirm') }
          }
        ],
        title: this.$t('SubscriberIms.logTitle'),
        isClose: true,
      },
      styles: {
        width: '810px',
        height: '760px',
        visible: false,
        model: true
      },
    gridTypeEnum: {
      rtttype: [,,this.$t('SubscriberIms.rtttype2'),,this.$t('SubscriberIms.rtttype4'),this.$t('SubscriberIms.rtttype5'),this.$t('SubscriberIms.rtttype6'),,this.$t('SubscriberIms.rtttype8')],
      rtttype2: [,this.$t('SubscriberIms.rtttype1'),this.$t('SubscriberIms.rtttype2'),this.$t('SubscriberIms.rtttype3'),this.$t('SubscriberIms.rtttype4'),this.$t('SubscriberIms.rtttype5'),this.$t('SubscriberIms.rtttype6_2'),,this.$t('SubscriberIms.rtttype8')],
    }
    };
  },
  methods: {
    closeDialogListTipPage() {
      this.$refs.dialogListPage.clear();
      this.$refs.dialogListPage.close()
    },
    actionComplete() {
      this.$refs.grid.selectRow(0, true);
      this.$refs.grid.selectRow(0, true);
    },
    notice(btn) {
      if (JSON.stringify(this.organization)=="{}") {
        EventBus.$emit('toast', {type: 'warning', content: this.$t('SubscriberIms.checkVpnTip')});
        return null;
      }
      if (btn === 'add') {
        this.addFunc();
      }
      if (btn === 'del') {
        this.delFunc();
      }
      if (btn === 'edit') {
        this.editFunc();
      }
      if (btn === 'refresh') {
        this.refreshFunc();
      }
      if (btn === 'search') {
        this.searchFunc();
      }
    },
    addFunc() {
      this.opCode = 'add';
      this.msgid = this.addMsgid;
      this.addDialog.element.title = this.$t('SubscriberIms.add');
      this.$nextTick(() => {
        this.$refs.infoDialog.mainHandler();
        this.$refs.addDialog.show();
      });
    },
    delFunc() {
      const record = this.getRecord();
      if (record) {
        this.$layer.confirm({
          title: this.$t('SubscriberIms.reminder'),
          msg: this.$t('SubscriberIms.deleteConfirm'),
          btn2: {
            msg: this.$t('SubscriberIms.confirm'),
            func: () => {
              this.$loading.showLoadding(this.$t('MML.loadingTip'));
              const url = '/lte/ems/subscriber/imsunms/requestCommon';
              this.msgid = this.delMsgid;
              const logParam = {
                module: 'res.subscriber#res.subscriber_ims#res.subscriber_ims_info',
                execFunName: 'subscriber.delStaff',
                exectype: 3,
                execData: []
              };
              const params = {
                vo: {
                  0: {
                    vo: record,
                    info: { msgid: this.delMsgid, neid: this.neid }
                  }
                },
                info: {
                  operation: 'bacthOperate'
                },
                log: logParam
              };
              const _showDatas = [];
              record.forEach((item) => {
                const showData = {};
                showData.operObj = item.staffnum;
                _showDatas.push(showData);
              });
              this.axios.post(url, params).then(response => {
                this.$loading.hideLoadding();
                const result = response['data']['resultVal'];
                this.$refs.dialogListPage.show();
                result.forEach((item, index) => {
                  _showDatas[index].operResult = item.display;
                  _showDatas[index].operCode = item.code;
                });
                this.$refs.dialogList.addOperetionResultList(_showDatas);
                this.getInfo(this.organization);
              });
            }
          },
          btn1: {
            msg: this.$t('SubscriberIms.cancel')
          }
        });
      }
    },
    editFunc() {
      const record = this.getRecord();
      if (record === null) {
        return null;
      }
      if (record.length != 1) {
        EventBus.$emit('toast', {type: 'warning', content: this.$t('SubscriberIms.checkDataMoreTip')});
        return null;
      }
      this.opCode = 'mod';
      this.msgid = this.modMsgid;
      this.addDialog.element.title = this.$t('SubscriberIms.mod');
      this.$nextTick(() => {
        this.$refs.infoDialog.mainHandler(record[0]);
        this.$refs.addDialog.show();
      });
    },
    clearQryParam() {
      this.qrySearchParam = null;
    },
    clearGridData() {
      this.dataSource = [];
      this.pageSettings.pageCount = 0;
      this.pageSettings.totalCount = 0;
    },
    refreshFunc() {
      this.clearQryParam();
      this.getInfo(this.organization);
    },
    searchFunc() {
      if(this.qrySearchParam) {
        this.$refs.infoSearchDialog.setData(this.qrySearchParam);
      }
      this.$nextTick(() => {
        this.$refs.searchDialog.show();
      });
    },
    getNode(node) {
      this.clearQryParam();
      this.getInfo(node);
    },
    treeFresh(node) {
      this.clearGridData();
      this.clearQryParam();
      this.getInfo(node);
    },
    dialogHide() {
      this.$refs.addDialog.clear();
      this.$refs.addDialog.close();
    },
    confirmAdd() {
      const url = '/lte/ems/subscriber/imsunms/requestCommon';
      const vo = this.$refs.infoDialog.getDatas();
      if (vo == null) {
        return null;
      }

      if(this.opCode == 'add'){
        vo['vpnid'] = this.vpnid;
      }
      vo['neid'] = this.neid;
      const logParam = {
        module: 'res.subscriber#res.subscriber_ims#res.subscriber_ims_info',
        execFunName: this.msgid == this.addMsgid ? 'subscriber.addStaff':'subscriber.modStaff',
        exectype: this.msgid == this.addMsgid ? 1 : 2,
        execData: []
      };
      const params = {
        vo: vo,
        info: {
          neid: this.neid,
          msgid: this.msgid
        },
        log: logParam
      }
      this.axios.post(url, params).then(response => {
        if (response.data.resultVal && response.data.resultVal.length > 0) {
          if (response.data.resultVal[0].code.split('.')[2] === '0') {
            EventBus.$emit('toast', { type: 'success', content: response.data.resultVal[0].display });
            this.$refs.addDialog.clear();
            this.$refs.addDialog.close();
            this.getInfo(this.organization);
          } else {
            EventBus.$emit('toast', { type: 'warning', content: response.data.resultVal[0].display });
          }
        } else {
          EventBus.$emit('toast', { type: 'warning', content: this.$t('SubscriberIms.resultReturnFailedTip') });
        }
      });
    },
    searchDialogHide() {
      this.$refs.searchDialog.clear();
      this.$refs.searchDialog.close();
    },
    searchDialogConfirm(){
      const url = '/lte/ems/subscriber/imsunms/requestCommon';
      const param = this.$refs.infoSearchDialog.getFormValue();
      this.qrySearchParam = { ...param };

      this.$refs.searchDialog.clear();
      this.$refs.searchDialog.close();
      this.getInfo(this.organization);
    },
    getRecord(){
      const record = this.$refs.grid.ej2Instances.getSelectedRecords();
      if (record == null || record == '') {
        EventBus.$emit('toast', {type: 'warning', content: this.$t('System.selectOneMessage')});
        return null;
      }
      return record;
    },
    getInfo(obj, isFirstPage = true){
      if (obj !== '' && typeof obj !== 'undefined') {
        this.organization = obj;
        this.neid = parseInt(this.organization.id.split('_')[0]);
        this.vpnid = parseInt(this.organization.id.split('_')[2]); //TODO
        this.vpnclass = parseInt(this.organization.level, 0) - 1;
        this.msgid = this.shwMsgid;
        this.pageSettings.pageNo = isFirstPage ? 1 : this.$refs.pager.ej2Instances.currentPage;

        const url = '/lte/ems/subscriber/imsunms/requestCommon';

        const params = {
          vo : { "vpnid":this.vpnid, "vpnClass":this.vpnclass, flag: 0, ...this.qrySearchParam },
          info : {
            neid: this.neid,
            msgid: this.msgid
          },
          page: {
            pageNo: this.pageSettings.pageNo,
            pageSize: this.pageSettings.pageSize
          }
        };
        this.axios.post(url, params).then(response => {
          const result = response.data.resultVal;
          const showRe = result.resultList;
          this.dataSource = showRe;
          this.pageSettings.totalCount = result.countrsp;
          setTimeout(()=> {
            if (result.countrsp === 0) { // 没有数据---组件会将domtokenlist增加e-checkbox-disabled属性
              const temp = this.$refs.grid.$el.childNodes[2].children[0].children[0].children[1].children[0].children[0].children[0].children[0].classList;
              if (temp.length > 2) {
                temp.remove('e-checkbox-disabled');
              }
            }
          }, 100);
        });
      } else {
        this.neid = '';
        this.vpnid = '';
        this.vpnclass = '';
      }
    },
    rtttypeFormat(grids,data){
      if (this.organization.neNode) {
        if(this.organization.neNode.softwareVersion.indexOf("_V22") > 0) {
          return this.gridTypeEnum.rtttype2[data.terminaltype];
        }
      }
      return this.gridTypeEnum.rtttype[data.terminaltype];
    },
  },
  components: {
    BasicLayout,
    CustomDialog,
    OrganizationalTree,
    ToolBar,
    ImsInfoDialog,
    DialogList,
    ImsInfoSearchDialog,
  },
  mounted() {
    this.$refs.organizationalTree.getOrganizationalTree();
  }
};
</script>
